import { FC } from 'react';

import cs from 'classnames';

import Section from 'layouts/Section/Section';

import ResponsiveAnimatedImage from 'components/ResponsiveAnimatedImage/ResponsiveAnimatedImage';
import SectionTitle from 'components/SectionTitle/SectionTitle';

import { useMobileDesign } from 'hooks/useMobileDesign';

import styles from './styles.module.scss';

const SHOW_MOBILE_COMPONENT_BREAKPOINT = 768;

interface BenefitModel {
  label: string;
  text: string;
  icon: React.ReactNode;
}

interface WhyChooseJoblioProps {
  title: string;
  benefits: BenefitModel[];
  imageSrc: string;
  highlightColor?: 'yellow' | 'blue';
  backgroundColor?: string;
  imagePosition?: 'left' | 'right';
  componentToShowOnMobile?: React.ReactNode;
}

const WhyChooseJoblio: FC<WhyChooseJoblioProps> = ({
  title,
  benefits,
  imageSrc,
  backgroundColor = '--white',
  highlightColor = 'yellow',
  imagePosition = 'right',
  componentToShowOnMobile
}: WhyChooseJoblioProps) => {
  const isShowMobileComponent = useMobileDesign(
    SHOW_MOBILE_COMPONENT_BREAKPOINT
  );

  return (
    <Section background={backgroundColor}>
      <SectionTitle
        highlightText={title}
        mainText="choose Joblio"
        color={highlightColor}
        textAlign="center"
      />
      <div
        className={cs(styles.twoColContainer, {
          [styles.reverse]: imagePosition === 'left'
        })}
      >
        <div className={styles.textSection}>
          <div className={cs(styles.consList, styles.textColorCompanies)}>
            {benefits.map((item) => (
              <div className={styles.consItem} key={item.label}>
                <div className={styles.consIcon}>{item.icon}</div>
                <div className={styles.consInfo}>
                  <h3>{item.label}</h3>
                  <p>{item.text}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {isShowMobileComponent && componentToShowOnMobile ? (
          <div className={styles.componentMobileWrap}>
            <div className={styles.componentMobile}>
              {componentToShowOnMobile}
            </div>
          </div>
        ) : (
          <div className={cs(styles.imageSection)}>
            <ResponsiveAnimatedImage src={imageSrc} />
          </div>
        )}
      </div>
    </Section>
  );
};

export default WhyChooseJoblio;
